export enum ComponentTypeEnum {
  Button = "button",
  LabelValue = "label_value",
  Title = "title",
  Link = "link",
  Line = "line",
  Header = "header",
}
